import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Menu, MenuItem, SubMenu } from "react-pro-sidebar";

import "./baseNavbar.css";
import IconButton from "../iconbutton/iconButton";
import { MAIN_LOGO, ROUTES, PROFILE_IMAGE } from "../../../constant";
import { loadData } from "../../../utils/localStorage";
import { bookCartListService } from "../../../modules/services";
import LogoutModal from "../../auth/logout/logout";


function BaseNavbar({ activeItem }) {
  const userData = JSON.parse(loadData("user"));
  const [logoutModal, setLogoutModal] = useState(false);
  const [cartUnreadCount, setCartUnreadCount] = useState([]);
  const theme = "light";
  const navigate = useNavigate();

  const handleLogout = () => {
    setLogoutModal(true);
  };
  const handleCloseLogoutModal = () => setLogoutModal(false);

  // hex to rgba converter
  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  useEffect(() => {
    refreshCart();
  }, []);

  useEffect(() => {
    const handler = () => refreshCart(); // your fetch logic

    window.addEventListener('cartUpdated', handler);
    return () => window.removeEventListener('cartUpdated', handler);
  }, []);

  const refreshCart = () => {
    if (userData !== null) {
      (async () => {
        const responseData = await bookCartListService({});

        if (responseData === "error" || !responseData.data) {
          return;
        }

        if (
          responseData.status_code !== 200 &&
          responseData.status_code !== 201
        ) {
          return;
        }
        setCartUnreadCount(responseData.data.item_count);
      })();
    }
  }

  const handleCartClick = () => {
    navigate(ROUTES.BOOKS_SELLING_CART_PAGE);
  }

  const themes = {
    light: {
      sidebar: {
        backgroundColor: "#ffffff",
        color: "#293659",
      },
      menu: {
        menuContent: "#fbfcfd",
        icon: "#293659",
        hover: {
          backgroundColor: "#fbb615",
          color: "#44596e",
        },
        disabled: {
          color: "#9fb6cf",
        },
      },
    },
    dark: {
      sidebar: {
        backgroundColor: "#0b2948",
        color: "#8ba1b7",
      },
      menu: {
        menuContent: "#082440",
        icon: "#59d0ff",
        hover: {
          backgroundColor: "#00458b",
          color: "#b6c8d9",
        },
        disabled: {
          color: "#3e5e7e",
        },
      },
    },
  };

  const menuItemStyles = {
    root: {
      fontSize: "16px",
      fontWeight: 400,
    },
    icon: {
      color: themes[theme].menu.icon,
    },
    SubMenuExpandIcon: {
      color: "#b6b7b9",
    },
    subMenuContent: ({ level }) => ({
      backgroundColor:
        level === 0
          ? hexToRgba(themes[theme].menu.menuContent, 1)
          : "transparent",
    }),
    button: {
      "&:hover": {
        backgroundColor: hexToRgba(
          themes[theme].menu.hover.backgroundColor,
          0.8
        ),
        color: themes[theme].menu.hover.color,
        fontWeight: "600",
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };

  const profilePopover = (
    <Popover id="popover-basic" style={{ width: "280px" }}>
      <Popover.Body>
        <div
          className="navigation-profile-popover-img-div"
          style={{ textAlign: "center", width: "100%" }}
        >
          <img
            src={
              userData?.profile_image ? userData?.profile_image : PROFILE_IMAGE
            }
            alt="user profile"
            width="45px"
            className="navigation-profile-popover-img"
            style={{ width: "70px" }}
          />
        </div>
        <div className="popover-navigation-text-div">
          <h6
            className="navigation-profile-popover-text"
            style={{ fontSize: "16px", marginBottom: "15px" }}
          >
            {userData?.first_name} {userData?.last_name}
          </h6>
          <h6 className="navigation-profile-popover-text-email">
            {userData?.role_permission?.role_name}
          </h6>
          <h6 className="navigation-profile-popover-text-email">
            {userData?.email}
          </h6>
        </div>
        <hr />
        <Menu menuItemStyles={menuItemStyles}>
          <MenuItem
            component={<Link to={ROUTES.DASHBOARD} />}
            icon={<i className="bi bi-bar-chart-fill"></i>}
          >
            Dashbaord
          </MenuItem>
          {/* <MenuItem
            component={<Link to={ROUTES.DASHBOARD} />}
            icon={<i className="bi bi-bell-fill"></i>}
          >
            Notifications
          </MenuItem> */}
          <MenuItem
            component={<Link to={ROUTES.BOOKS_SELLING_CART_PAGE} />}
            icon={<i className="bi bi-cart-fill"></i>}
          >
            Cart Itmes
          </MenuItem>
          <MenuItem
            component={<Link to={ROUTES.PROFILE} />}
            icon={<i className="bi bi-person-circle"></i>}
          >
            Profile
          </MenuItem>
          <MenuItem
            onClick={handleLogout}
            icon={<i className="bi bi-power"></i>}
          >
            Logout
          </MenuItem>
        </Menu>
      </Popover.Body>
    </Popover>
  );

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="white"
      variant="white"
      className="main-class"
      sticky="top"
    >
      {LogoutModal({ logoutModal, handleCloseLogoutModal })}
      <Container fluid>
        <Navbar.Brand
          href="https://fizrobotics.com/"
          style={{ marginLeft: "10%" }}
        >
          <img
            src={MAIN_LOGO}
            width="193.6px"
            height="70.4px"
            className="d-inline-block align-top navbar-logo"
            alt="FRS logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              href="https://fizrobotics.com/"
              className="navbar-navs-text"
            >
              HOME
            </Nav.Link>
            <Nav.Link
              eventKey={2}
              href="https://fizrobotics.com/fire-robotics-lab/"
              className="navbar-navs-text"
            >
              LABS
            </Nav.Link>
            <Nav.Link
              eventKey={2}
              href="https://fizrobotics.com/workshops/"
              className="navbar-navs-text"
            >
              WORKSHOP
            </Nav.Link>
            <Nav.Link
              eventKey={2}
              as={Link}
              to={ROUTES.BOOKS_SELLING_HOME_PAGE}
              className={
                activeItem === "BOOKS"
                  ? "navbar-navs-text navbar-navs-text-active"
                  : "navbar-navs-text"
              }
            >
              BOOKS
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto" style={{ marginRight: "1%" }}>
            {userData ? (
              <>
                <div style={{ display: "flex" }}>
                  <div>
                    <IconButton
                      iconName="bi-cart-fill"
                      badgeCount={cartUnreadCount}
                      onChange={handleCartClick}
                      customStyle={{
                        fontSize: "20px",
                        height: "53px",
                        width: "40px",
                        color: "#293659",
                      }}
                    />
                  </div>
                  <div>
                    {/* <IconButton
                      iconName="bi-bell-fill"
                      badgeCount={0}
                      customStyle={{
                        fontSize: "20px",
                        height: "53px",
                        width: "40px",
                        color: "#293659",
                        marginRight: "15px",
                      }}
                    /> */}
                  </div>
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    rootClose
                    overlay={profilePopover}
                  >
                    <div className="navigation-profile-div">
                      <div className="navigation-profile-img-div">
                        <img
                          src={
                            userData?.profile_image
                              ? userData?.profile_image
                              : PROFILE_IMAGE
                          }
                          alt="user profile"
                          width="45px"
                          className="navigation-profile-img"
                        />
                      </div>
                      <div className="navigation-text-div">
                        <h6 className="navigation-profile-text">
                          {userData?.first_name} {userData?.last_name}
                        </h6>
                        <h6 className="navigation-profile-text-email">
                          {userData?.email}
                        </h6>
                      </div>
                      <div style={{ margin: "auto", marginRight: "5px" }}>
                        <IconButton
                          iconName="bi-chevron-down"
                          customStyle={{ fontSize: "18px" }}
                          onChange={() => {}}
                        />
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              </>
            ) : (
              <>
                <Nav.Link
                  eventKey={2}
                  as={Link}
                  to={ROUTES.LOGIN}
                  className={
                    activeItem === "SIGN_IN"
                      ? "navbar-navs-text navbar-navs-text-active"
                      : "navbar-navs-text"
                  }
                >
                  SIGN IN
                </Nav.Link>
                <Nav.Link
                  eventKey={2}
                  as={Link}
                  to={ROUTES.SIGN_UP}
                  className={
                    activeItem === "SIGN_UP"
                      ? "navbar-navs-text navbar-navs-text-active"
                      : "navbar-navs-text"
                  }
                >
                  SIGN UP
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BaseNavbar;
